import React from "react";
import axios from "axios";
import { List } from "components/category/List";
import { AuthContext } from "auth";
import { formatDate } from "date";

export function CategoryList() {
  const authContext = React.useContext(AuthContext);
  const [state, dispatch] = React.useReducer(
    (s, action) => {
      switch (action.type) {
        case "FETCH_SUCCESS":
          return {
            ...s,
            categoryList: action.categoryList,
            isProcessing: false,
            isError: false,
          };
        case "FETCH_ERROR":
          return {
            ...s,
            isProcessing: false,
            isError: true,
          };
        case "CREATE_CLICKED":
          return {
            ...s,
            showCreationForm: true,
          };
        case "CANCEL_CREATE_CLICKED":
        case "CREATE_SUCCESS":
        case "EDIT_SUCCESS":
          return {
            ...s,
            showCreationForm: false,
          };
        default:
          return s;
      }
    },
    {
      categoryList: [],
      isProcessing: true,
      isError: false,
      showCreationForm: false,
    }
  );

  const fetchList = async () => {
    try {
      const { data: categoryList } = await fetchCategoryList();
      dispatch({
        type: "FETCH_SUCCESS",
        categoryList: categoryList.map((item) => {
          return {
            ...item,
            created_at: formatDate(new Date(item.created_at)),
          };
        }),
      });
    } catch (e) {
      console.error(e);
      dispatch({
        type: "FETCH_ERROR",
      });
    }
  };

  React.useEffect(() => {
    fetchList();
  }, []);

  const onCreateSubmit = async (category) => {
    try {
      await createCategory(authContext.user, category);
      dispatch({ type: "CREATE_SUCCESS" });
      await fetchList();
    } catch (e) {
      console.error(e);
    }
  };

  const onEditSubmit = async (category) => {
    try {
      await updateCategory(authContext.user, category);
      dispatch({ type: "EDIT_SUCCESS" });
      await fetchList();
    } catch (e) {
      console.error(e);
    }
  };

  return (
    <List
      categoryList={state.categoryList}
      showCreationForm={state.showCreationForm}
      onCreateClick={() => {
        dispatch({ type: "CREATE_CLICKED" });
      }}
      onCancelCreateClick={() => dispatch({ type: "CANCEL_CREATE_CLICKED" })}
      onCreateSubmit={onCreateSubmit}
      onEditSubmit={onEditSubmit}
    ></List>
  );
}

export async function fetchCategoryList() {
  return axios.request({
    url: `/r-api/program_category?order=title.asc`,
    method: "GET",
  });
}

async function createCategory(user, category) {
  return axios.request({
    url: `/program-category-api/category`,
    method: "POST",
    data: {
      ...category,
      created_by: user.uid,
    },
  });
}

async function updateCategory(user, category) {
  return axios.request({
    url: `/program-category-api/category/${category.id}`,
    method: "PUT",
    data: {
      category,
      updated_by: user.uid,
    },
  });
}
